// Shared rules for scheduled delivery orders: when staff must pick a driver
// pickup time, how long the drive is, and when to remind them.

export const TEMP_SUPPORTED_SHOPS = [
  'pablitos', 'pablitostacosnoho', 'pablitostacosburbank', 'pablitostacosvannuys', 'tortas', 'submarineking', 'playa', 'bierhaus',
  'pablitostacosstudio',   'pablitostacosmoorpark', 'elcriollo', 'elcriollovannuys', 'meltit',
  'pablitostacosvictory',   'aleppokitchen', 'romancing', 'dads', 'kiin', 'westernwok', 'sidewalk',
  'tokyoya', 'californiaeatery', 'latarvana', 'sushidon', 'chili-johns', 'mgrill', 'psh', 'phoburbank',
   'larryschilidog', 'leonorsvegetarian', 'tinhorn', 'liquorpalace', 'newdeal', 'harvest', 'romancing', 'costa',
   'lams', 'moores', 'urban', 'taq', 'urban', 'lascasitas', 'lancers', 'lemon', 'losamigos', 'craveoaks', 'electric',
   'mexcocina', 'mrkabob', 'coralcafe', 'knight', 'wildcarvery', 'muiishi', 'hayats', 'goldenchopsticks', 'beachwood', 'poncitlan', 'poncitlanpasa'
 ]

const MINUTE = 60 * 1000
export const REMIND_BEFORE_DUE_MS = 45 * MINUTE
export const REMINDER_OPTION_BEFORE_DUE_MS = 60 * MINUTE

// deliveryTime is only set when the customer scheduled the delivery
export function getScheduledDeliveryTS (order = {}) {
  if (order.cartType !== 'DELIVERY') { return null }
  return Number(order.deliveryTime) || null
}

// travelTimeMinutes comes from the Google Directions query at checkout (newer orders only)
export function getTravelTime (order = {}) {
  const savedMinutes = Number(order.travelTimeMinutes)
  if (savedMinutes > 0) {
    return {minutes: savedMinutes, isEstimate: false}
  }
  const miles = Number(order.distanceInMiles) || 0
  return {minutes: Math.round(15 + 3 * miles), isEstimate: true}
}

export function usesDriverPickupPicker (r_id, settings = {}) {
  const {delivery = {}} = settings
  return (TEMP_SUPPORTED_SHOPS.indexOf(r_id) !== -1) || !!delivery.deliverWithPostmates
}

// true once staff made a choice for the driver (time, no driver, or accepted for self delivery)
export function isDriverChoiceMade (order = {}, settings = {}) {
  if (order.pickupReadyTS || order.doNotDispatch) { return true }
  const {delivery = {}} = settings
  if (delivery.selfDeliveryWithOptionalPostmates || !usesDriverPickupPicker(order.r_id, settings)) {
    return !!order.orderAcceptedByShop
  }
  return false
}

// moments an unhandled scheduled delivery order should ring again
export function getReminderPoints (order = {}) {
  const scheduledTS = getScheduledDeliveryTS(order)
  if (!scheduledTS) { return [] }
  const c_at = Number(order.c_at) || 0
  const points = [{key: 'beforeDue', ts: scheduledTS - REMIND_BEFORE_DUE_MS}]
  if (Number(order.pickupReminderTS)) {
    points.push({key: 'requested', ts: Number(order.pickupReminderTS)})
  }
  // orders placed after a reminder point already rang as a new order
  return points.filter(({ts}) => ts > c_at)
}
